<!-- 🚀 CANDADO DE ARQUITECTURA: Desactiva por completo la caché de hidratación de Angular SSR -->
<div ngSkipHydration>

  <div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;">
    
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <div>
        <h2 class="h5 m-0 fw-bold text-dark">Órdenes de Recepción Vehicular</h2>
        <span class="small text-muted font-monospace">JDE Reception Matrix / Active Orders</span>
      </div>
      <a class="btn btn-primary btn-sm px-4 fw-bold shadow-sm" routerLink="/recepciones/add" style="border-radius: 6px;">
        ➕ Nueva Recepción
      </a>
    </div>

    <!-- 🔍 Barra de Búsqueda Reactiva -->
    <div class="card mb-3 border-0 shadow-sm bg-light">
      <div class="card-body p-2">
        <div class="input-group input-group-sm">
          <span class="input-group-text bg-white border-end-0">🔍</span>
          <input type="text" class="form-control border-start-0 ps-0 text-uppercase" name="buscarOrden"
                 [(ngModel)]="filtroTexto" (input)="filtrarRecepciones()" placeholder="Buscar orden por Folio, Placas, Vehículo o AN8 del cliente...">
        </div>
      </div>
    </div>

    <!-- 📊 Tabla de Órdenes -->
    <table class="table table-hover table-striped border shadow-sm align-middle">
      <thead class="table-dark">
        <tr>
          <th scope="col" style="width: 130px;">FOLIO</th>
          <th scope="col" style="width: 120px;">FECHA</th>
          <th scope="col">VEHÍCULO / PLACAS</th>
          <th scope="col">AN8 - CLIENTE</th>
          <th scope="col" class="text-center" style="width: 140px;">COMBÚSTIBLE</th>
          <th scope="col" class="text-center" style="width: 120px;">ACCIONES</th>
        </tr>
      </thead>
      <tbody>
        <!-- 🚀 CAMBIADO: Ahora itera sobre el getter 'recepcionesPaginadas' para el corte automático de 10 renglones -->
        <tr *ngFor="let r of recepcionesPaginadas">
          <th scope="row" class="font-monospace text-primary fw-bold">{{ r.folio }}</th>
          <td class="font-monospace text-secondary">{{ r.fecha_entrada | date:'dd/MM/yyyy' }}</td>
          <td>
            <span class="text-uppercase fw-semibold text-secondary">{{ r.unidad.submarca }}</span>
            <span class="fw-semibold text-uppercase"> - {{ r.unidad.placas }}</span>           
          </td>
          <td class="text-uppercase fw-semibold text-secondary">
            {{ r.customer.an8 }} - {{ r.customer.alph }}
          </td>
          <td class="text-center">
            <span class="badge bg-warning text-dark font-monospace fw-bold px-2 py-1">{{ r.nivelCombustible }}</span>
          </td>

          <!-- Columna de Acciones de tu Rejilla -->
          <td>
            <div class="acciones-workflow-container" style="display: flex; gap: 8px; align-items: center;">
              
              <!-- 🛡️ INTEGRIDAD JDE: Bloqueamos el botón si la orden ya avanzó a Presupuestado, Reparación o Entregado -->
              <button class="btn-edit" (click)="abrirEditor(r)" title="Editar Detalles"
                      [disabled]="r.estatus === 'PRESUPUESTADO' || r.estatus === 'EN_REPARACION' || r.estatus === 'ENTREGADO'"
                      [ngStyle]="{
                        'opacity': (r.estatus === 'PRESUPUESTADO' || r.estatus === 'EN_REPARACION' || r.estatus === 'ENTREGADO') ? '0.5' : '1',
                        'cursor': (r.estatus === 'PRESUPUESTADO' || r.estatus === 'EN_REPARACION' || r.estatus === 'ENTREGADO') ? 'not-allowed' : 'pointer'
                      }">
                ⚙️ Editar
              </button>

			        <!-- =========================================================================
                  ⚖️ RENDERIZADO DINÁMICO DE WORKFLOW DE FIRMAS JURÍDICAS Y COMERCIALES
                  ========================================================================= -->

              <!-- Estado 1: Vehículo Recibido de Patio (Pendiente de Validación Legal Inicial) -->
              <ng-container *ngIf="r.estatus === 'PENDIENTE_FIRMA'">
                <button type="button" class="btn-firma-entrada" (click)="lanzarFirmaEntrada(r)" 
                        style="background-color: #dc2626; color: white; border: none; padding: 6px 12px; border-radius: 4px; font-weight: bold; cursor: pointer;">
                  📝 Firmar Entrada
                </button>
              </ng-container>

              <!-- Estado 2: Vehículo Presupuestado (Esperando Autorización Comercial de Montos) -->
              <ng-container *ngIf="r.estatus === 'PRESUPUESTADO'">
                <button type="button" class="btn-firma-cotizacion" (click)="lanzarFirmaCotizacion(r)"
                        style="background-color: #2563eb; color: white; border: none; padding: 6px 12px; border-radius: 4px; font-weight: bold; cursor: pointer;">
                  💰 Firmar Cotización
                </button>
              </ng-container>

              <!-- Estado 3: Trabajo Concluido (Listo para Entrega Física y Liberación de Responsabilidad) -->
              <ng-container *ngIf="r.estatus === 'TERMINADO'">
                <button type="button" class="btn-firma-entrega" (click)="lanzarFirmaWorkflow(r, 'ENTREGA')"
                        style="background-color: #16a34a; color: white; border: none; padding: 6px 12px; border-radius: 4px; font-weight: bold; cursor: pointer;">
                  🚗 Firmar Entrega
                </button>
              </ng-container>

              <!-- Modificación en tu recepciones-list.html -->
              <ng-container *ngIf="r.estatus === 'AUTORIZADA'">
                <button type="button" class="btn-cotizar-rampa" 
                        (click)="irAPresupuesto(r.id)"
                        style="background-color: #16a34a; color: white; border: none; padding: 6px 12px; border-radius: 4px; font-weight: bold; cursor: pointer;"
                        title="Evaluar Croquis y Cotizar Renglones">
                  🛠️ Evaluar y Cotizar
                </button>
              </ng-container>



              <!-- Estado 4: Vehículo en Rampa de Trabajo (Mano de Obra Activa) -->
              <span *ngIf="r.estatus === 'EN_REPARACION'" class="badge-reparacion-ok" 
                    style="color: #1d4ed8; background-color: #dbeafe; padding: 6px 12px; border-radius: 4px; font-size: 0.78rem; font-weight: bold; border: 1px solid #bfdbfe;">
                👨‍🔧 En Reparación
              </span>

              <!-- Indicador Adicional: Presupuesto Pendiente en el celular del Cliente -->
              <span *ngIf="r.estatus === 'PRESUPUESTADO'" class="badge-waiting-client" 
                    style="color: #b45309; background-color: #fef3c7; padding: 4px 8px; border-radius: 12px; font-size: 11px; font-weight: 500; display: inline-block; margin-left: 4px;">
                ⏳ Esperando Respuesta de Cliente
              </span>



              <!-- Indicador Final de Proceso Terminado y Entregado -->
              <span *ngIf="r.estatus === 'ENTREGADO'" class="badge-legal-final" 
                    style="color: #475569; background-color: #f1f5f9; padding: 4px 8px; border-radius: 12px; font-size: 11px; font-weight: 500;">
                🔒 Archivado
              </span>

            </div>
          </td>          

        </tr>
        <tr *ngIf="recepcionesFiltradas.length === 0">
          <td colspan="6" class="text-center text-muted py-4">No se encontraron órdenes de recepción activas en el taller.</td>
        </tr>
      </tbody>
    </table>

    <!-- ========================================================================= -->
    <!-- 🎛 Rose de Paginación Ergonómica: Botones a la izquierda y Conteo a la derecha -->
    <!-- ========================================================================= -->
    <div class="d-flex justify-content-between align-items-center mt-3 border-top pt-2">
      
      <!-- 🧭 BARRA DE PAGINACIÓN INTERACTIVA CON SALTOS EXTREMOS (IZQUIERDA) -->
      <nav aria-label="Navegación de recepciones">
        <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">
          
          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(1)" style="cursor: pointer;" title="Ir a la primera página">
              ⏮️ Primera
            </button>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)" style="cursor: pointer;">
              ◀️ Anterior
            </button>
          </li>

          <li class="page-item disabled">
            <span class="page-link bg-light text-dark font-monospace border fw-bold px-3">
              PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
            </span>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)" style="cursor: pointer;">
              Siguiente ▶️
            </button>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(totalPaginas)" style="cursor: pointer;" title="Ir a la última página">
              Última ⏭️
            </button>
          </li>

        </ul>
      </nav>

      <!-- 📊 LEYENDAS ESTADÍSTICAS INDEXADAS (DERECHA) -->
      <span class="text-muted small text-end">
        Mostrando órdenes del <strong>{{ ((paginaActual - 1) * registrosPorPagina) + 1 }}</strong> 
        al <strong>{{ Math.min(paginaActual * registrosPorPagina, recepcionesFiltradas.length) }}</strong> 
        de un total de <strong>{{ recepcionesFiltradas.length }}</strong> indexadas en red.
      </span>

    </div>

  </div>

  <!-- ========================================================================= -->
  <!-- 🌟 INYECTADO: CONTENEDOR FLOTANTE UNIVERSAL DE TOASTS CORPORATIVOS          -->
  <!-- ========================================================================= -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
    <div *ngFor="let toast of toastService.toasts" 
         class="toast show shadow border-0 mb-2" 
         [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
         role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
        <strong class="me-auto d-flex align-items-center gap-2">
          <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
          {{ toast.title }}
        </strong>
        <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
      </div>
      <div class="toast-body pt-0" style="font-size: 0.85rem;">
        {{ toast.text }}
      </div>
    </div>
  </div>

</div>

<router-outlet></router-outlet>